<app-gradient-bg class="fade-in"></app-gradient-bg>

<div class="flex-center-wrapper">
	<img src="/assets/img/mira_logo.svg" alt="logo" class="logo" />

	@switch (state()) {
		@case (HomeState.LOGIN) {
			<app-login-form
				(onSubmit)="onLogin($event)"
				(onSwitchState)="switchState($event)"
				[loading]="loading()"
			></app-login-form>
		}
		@case (HomeState.LOGGED_IN) {
			<ul class="fade-in-with-delay-5000">
				<li><a (click)="loggedInService.logout()">Logout</a></li>
				@if (isAdmin()) {
					<li>
						<a (click)="nav.navigate(['/', 'my', 'admin'])">Admin</a>
					</li>
				}
			</ul>
		}
		@case (HomeState.CHECK_EMAIL) {
			<div class="check-email">
				@if (signupLinkResend()) {
					<h2>Check your email for your new sign-up link.</h2>
					@if (!UserUtils.isUsernameEmail(lastEmailEntered())) {
						<h2>For Student ID accounts, your sign-up link has been sent to your teacher.</h2>
					}
				} @else {
					<h2>Check your email for your password reset.</h2>
					<h2>For Student ID accounts, your password reset has been sent to your teacher.</h2>
				}
			</div>
		}
		@case (HomeState.CREATE_ACCOUNT) {
			<app-create-account-form
				(onSubmit)="onCreateAccount($event)"
				(onSwitchState)="switchState($event)"
				[loading]="loading()"
			></app-create-account-form>
		}
		@case (HomeState.CHANGE_TEMPORARY_PASSWORD) {
			@if (setupLinkValidating()) {
				<div class="link-validation">
					<nz-spin nzSimple nzSize="large"></nz-spin>
				</div>
			} @else if (setupLinkValidationFailed()) {
				<div class="check-email link-validation">
					<p>Unable to verify this sign-up link. Please try again.</p>
					<button nz-button nzType="primary" (click)="retryAccountSetupLinkValidation()">Try Again</button>
				</div>
			} @else {
				<app-change-temporary-password-form
					[studentId]="lastStudentId()"
					[setupCode]="setupCode()"
					[setupLinkExpired]="setupLinkExpired()"
					(onSubmit)="onChangedTemporaryPassword($event)"
					(onSwitchState)="switchState($event)"
					[loading]="loading()"
				></app-change-temporary-password-form>
			}
		}
		@case (HomeState.VERIFY_ACCOUNT) {
			<app-verify-account-form
				[email]="lastEmailEntered()"
				(onSubmit)="onVerifyAccount($event)"
				(onSwitchState)="switchState($event)"
				[loading]="loading()"
			></app-verify-account-form>
		}
		@case (HomeState.RESET_PASSWORD_REQUIRED) {
			<app-reset-password-form
				[email]="lastEmailEntered()"
				(onSubmit)="onResetPassword($event)"
				(onSwitchState)="switchState($event)"
				[loading]="loading()"
			></app-reset-password-form>
		}
		@case (HomeState.FORGOT_PASSWORD) {
			<app-forgot-password-form
				(onSubmit)="onForgotPassword($event)"
				(onSwitchState)="switchState($event)"
				[loading]="loading()"
				[signupLinkResend]="signupLinkResend()"
			></app-forgot-password-form>
		}
		@case (HomeState.CONFIRM_FORGOT_PASSWORD) {
			<app-confirm-forgot-password-form
				(onSubmit)="onConfirmForgotPassword($event)"
				(onSwitchState)="switchState($event)"
				[loading]="loading()"
			></app-confirm-forgot-password-form>
		}
	}
</div>
